import { graphql, useFragment, useLazyLoadQuery } from "react-relay";
import { ConnectAdminCreateInitQuery } from "./__generated__/ConnectAdminCreateInitQuery.graphql";
import { ActivityIndicator, FlatList } from "react-native";
import { AHSeparator, AHTodoCategoryIcon, ListItem } from "arkh";

import { StoreAdminNavigationScreenProps } from "../StoreAdmin/StoreAdminNavigation";
import { useCreateConnectInbox } from "./useCreateConnectInbox";
import { ConnectAdminCreateInit_item$key } from "./__generated__/ConnectAdminCreateInit_item.graphql";
import { LazyQueryNetworkBoundrary } from "@/src/components/mobile/QueryNetworkBoundrary";
import { useCallback } from "react";

export function ConnectAdminCreateInitScreen(
  props: StoreAdminNavigationScreenProps<"ConnectAdminCreateInit">
) {
  return (
    <LazyQueryNetworkBoundrary newFetchKeyOnNavigation>
      {useCallback(
        (fetchKey) => (
          <ConnectAdminCreateInit {...props} fetchKey={fetchKey} />
        ),
        [props]
      )}
    </LazyQueryNetworkBoundrary>
  );
}
function ConnectAdminCreateInit(
  props: StoreAdminNavigationScreenProps<"ConnectAdminCreateInit"> & {
    fetchKey: string;
  }
) {
  const data = useLazyLoadQuery<ConnectAdminCreateInitQuery>(
    graphql`
      query ConnectAdminCreateInitQuery {
        store {
          todoCategories(includeDefault: true) {
            id
            title
            icon
            ...ConnectAdminCreateInit_item
          }
        }
      }
    `,
    {},
    {
      fetchKey: props.fetchKey,
      fetchPolicy: "store-and-network",
    }
  );

  return (
    <FlatList
      data={data.store.todoCategories}
      ItemSeparatorComponent={AHSeparator}
      renderItem={({ item }) => (
        <TodoCategoryListItem
          todoCategory={item}
          onPress={(inboxId) => {
            props.navigation.replace("ConnectAdminInbox", {
              inboxId: inboxId,
            });
          }}
        />
      )}
    />
  );
}

function TodoCategoryListItem(props: {
  todoCategory: ConnectAdminCreateInit_item$key;
  onPress: (inboxId: string) => void;
}) {
  const item = useFragment(
    graphql`
      fragment ConnectAdminCreateInit_item on TodoCategory {
        id
        title
        icon
      }
    `,
    props.todoCategory
  );
  const [createItem, createLoading] = useCreateConnectInbox();

  return (
    <ListItem
      onPress={() => {
        createItem({
          variables: {
            input: {
              todoCategoryId: item.id,
            },
          },
          onCompleted: (data) => {
            props.onPress(data.store.createConnectInbox.connectInbox.id);
          },
        });
      }}
      left={item.icon ? <AHTodoCategoryIcon icon={item.icon} /> : null}
      right={createLoading ? <ActivityIndicator /> : <ListItem.NavArrow />}
    >
      <ListItem.Title>{item.title}</ListItem.Title>
    </ListItem>
  );
}
